module.exports = __webpack_public_path__ + "img/helpbox-6.05e0ca46.png";